import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { countProjectsFromRedux } from "../../utils/analyticsUtilsBackend";
import "../analytics/ProjectsKPI.css";

const ProjectsKPIBackend = ({
  selectedPeriod = "7 derniers jours",
  email = "",
}) => {
  const storeProjects = useSelector((state) => state?.project?.projects);
  // Also allow reading an optional backend userObj structure from sessions slice if available
  const userObj = useSelector((state) => state?.sessions?.userObj);

  const count = useMemo(() => {
    // If backend provided a userObj like { email: { projectId: timestamp, ... }, ... }
    console.log("check userree", userObj);
    if (userObj && typeof userObj === "object" && !Array.isArray(userObj)) {
      try {
        console.log("emmem²", email);
        if (email && email.trim()) {
          console.log("ememme");
          // Count projects only for the filtered email
          const rec =
            userObj[email] ||
            userObj[email.toLowerCase()] ||
            userObj[email.trim()] ||
            null;
          if (!rec || typeof rec !== "object") return 0;
          // If values are timestamps, we could apply period filtering later; for now, count entries
          return Object.keys(rec).length;
        }
        // No email filter: sum all user projects
        let total = 0;
        Object.values(userObj).forEach((val) => {
          if (val && typeof val === "object") total += Object.keys(val).length;
        });
        return total;
      } catch {
        // fallback to Redux list below
      }
    }
    // Default path: use Redux projects list with period filtering
    return countProjectsFromRedux(storeProjects || [], selectedPeriod, email);
  }, [storeProjects, userObj, selectedPeriod, email]);

  return (
    <div
      className="number-card-value"
      style={{ fontSize: "2.5rem", fontWeight: "700", color: "#38a169" }}
    >
      {count}
    </div>
  );
};

export default ProjectsKPIBackend;
